import { z } from "zod"

import { commandEnvelopeV1Schema } from "./command-envelope-v1.js"
import {
  FIELD_BEFORE_AFTER_VIDEO_MAXIMUM_BYTES,
  FIELD_BEFORE_AFTER_VIDEO_MAXIMUM_DURATION_MS,
} from "./field-before-after-v2.js"
import { fieldBeforeAfterSourceV1Schema } from "./field-before-after-v1.js"
import { FIELD_MEDIA_MAXIMUM_BYTES } from "./field-media-v1.js"
import { entityIdSchema } from "./identifiers.js"

export const fieldOrdinaryMediaRoleV1Schema = z.enum(["Event", "Property"])

export const fieldMediaUploadInitiateV4Schema = z.object({
  requestVersion: z.literal(4),
  mediaId: entityIdSchema,
  visitId: entityIdSchema,
  role: fieldOrdinaryMediaRoleV1Schema,
  source: fieldBeforeAfterSourceV1Schema,
  fileName: z.string().min(1).max(128).regex(/^[A-Za-z0-9][A-Za-z0-9._ -]*$/),
  mediaType: z.enum(["image/jpeg", "image/png", "video/mp4"]),
  sizeBytes: z.number().int().min(1).max(FIELD_BEFORE_AFTER_VIDEO_MAXIMUM_BYTES).safe(),
  sha256: z.string().regex(/^[0-9a-f]{64}$/),
  capturedAt: z.iso.datetime({ offset: true }),
  durationMs: z.number().int().min(1).max(FIELD_BEFORE_AFTER_VIDEO_MAXIMUM_DURATION_MS).safe().nullable(),
  associationCommand: commandEnvelopeV1Schema,
}).strict().superRefine((request, context) => {
  const isVideo = request.mediaType === "video/mp4"
  const command = request.associationCommand
  const payload = command.payload
  if (
    isVideo !== (request.durationMs !== null) ||
    (!isVideo && request.sizeBytes > FIELD_MEDIA_MAXIMUM_BYTES) ||
    command.commandType !== "visit.media.associate" ||
    command.commandVersion !== 4 ||
    command.context.entityType !== "visit" ||
    command.context.entityId !== request.visitId ||
    command.expectedVersion === null ||
    payload.mediaId !== request.mediaId ||
    payload.visitId !== request.visitId ||
    payload.role !== request.role ||
    payload.source !== request.source ||
    payload.fileName !== request.fileName ||
    payload.mediaType !== request.mediaType ||
    payload.sizeBytes !== request.sizeBytes ||
    payload.sha256 !== request.sha256 ||
    payload.capturedAt !== request.capturedAt ||
    payload.durationMs !== request.durationMs ||
    payload.storageReference !== `field-media:${request.mediaId}`
  ) {
    context.addIssue({
      code: "custom",
      path: ["associationCommand"],
      message: "Ordinary Visit media association must match the upload.",
    })
  }
})

export type FieldOrdinaryMediaRoleV1 = z.infer<typeof fieldOrdinaryMediaRoleV1Schema>
export type FieldMediaUploadInitiateV4 = z.infer<typeof fieldMediaUploadInitiateV4Schema>
